import _chunk from 'lodash/chunk';
import { BREAKPOINTS } from '../constants';

/**
 * Get the highest GridItem header height in each row (maxHeaderHeight),
 * and set all headers to maxHeaderHeight
 *
 * @param {Array} gridRows - sets of 3 GridItems in each grid row
 * @private
 */
function _setEvenHeaderHeights(gridRows) {
  gridRows.forEach(gridRow => {
    let maxHeaderHeight = 'auto';

    if ($(window).width() >= BREAKPOINTS.MD) {
      maxHeaderHeight = gridRow.reduce(
        (sum, gridItem) => {
          const $gridItemHeader = $(gridItem).find('.grid-item__header');

          // reset header height to auto before getting the height
          $gridItemHeader.height('auto');
          const headerHeight = $gridItemHeader.height();

          return sum > headerHeight ? sum : headerHeight;
        },
        $(gridRow[0]).find('.grid-item__header').height('auto').height()
      );
    }

    gridRow.forEach(gridItem => $(gridItem).find('.grid-item__header').height(maxHeaderHeight));
  });
}

/**
 * Ensure the headers of GridItems in the same row are the same height, all the time
 * This feature works as long as GridItems in the design/template remain .col-md-4 (3 in a row)
 */
function initEvenHeaderHeights() {
  const gridRows = _chunk($('.row > .grid-item'), 3);

  if (gridRows.length > 0) {
    _setEvenHeaderHeights(gridRows);

    // ensure GridItem header height is updated even after user resizes window
    $(window).resize(() => {
      _setEvenHeaderHeights(gridRows);
    });
  }
}

/**
 * All instances of CodaPage
 */
function CodaPage() {
    initEvenHeaderHeights();
}

export default CodaPage;



// WEBPACK FOOTER //
// ./javascript/pages/CodaPage.js